<div class="placeholder flex-row center-center">
  <button (click)="diminuirFonte()" [disabled]="!(podeDiminuir | async)">
    <mat-icon
      svgIcon="decrease-font"
      class="btnControle clickable statusbar-icon-decrease"
      matTooltip="Diminuir tamanho da fonte"
      aria-label="diminuir fonte"
    >
    </mat-icon>
  </button>

  <button (click)="aumentarFonte()" [disabled]="!(podeAumentar | async)">
    <mat-icon
      svgIcon="increase-font"
      class="btnControle clickable statusbar-icon"
      matTooltip="Aumentar tamanho da fonte"
      aria-label="aumentar fonte"
    >
    </mat-icon>
  </button>
</div>
